theme.footerSection = (function () {
  function footer() {
    let accordion = true;

    const footerWidgetAccordion = function () {
      accordion = false;

      document.querySelectorAll('.footer__widget_toggle').forEach(function (item) {
        item.addEventListener('click', function () {
          const footerWidget = this.closest('.footer__widget');
          const footerWidgetInner = footerWidget && footerWidget.querySelector('.footer__widget_inner');

          if (!footerWidget || !footerWidgetInner) return;

          if (footerWidget.classList.contains('active')) {
            footerWidget.classList.remove('active');
            this.setAttribute('aria-expanded', 'false');
            slideUp(footerWidgetInner);
          } else {
            footerWidget.classList.add('active');
            this.setAttribute('aria-expanded', 'true');
            slideDown(footerWidgetInner);

            getSiblings(footerWidget.parentElement).forEach(function (sibling) {
              const siblingWidget = sibling.querySelector('.footer__widget');
              const siblingInner = siblingWidget && siblingWidget.querySelector('.footer__widget_inner');
              const siblingToggle = siblingWidget && siblingWidget.querySelector('.footer__widget_toggle');

              if (!siblingWidget || !siblingInner) return;

              siblingWidget.classList.remove('active');
              if (siblingToggle) siblingToggle.setAttribute('aria-expanded', 'false');
              slideUp(siblingInner);
            });
          }
        });
      });
    };

    if (accordion) footerWidgetAccordion();

    window.addEventListener('resize', function () {
      document.querySelectorAll('.footer__widget').forEach(function (item) {
        if (window.outerWidth >= 768) {
          item.classList.remove('active');
          const inner = item.querySelector('.footer__widget_inner');
          const toggle = item.querySelector('.footer__widget_toggle');
          if (inner) inner.style.display = '';
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  return footer;
})();
